export default __webpack_public_path__ + "static/char-s-41-ja-fabdaa94f883845ef8e0dedab5fa84d3.png";